import { setEmail } from "../../domain/subscribe/subscribeModel"
import { UpdateSubscribeStore, updateSubscribeUseCase } from "./updateSubscribeUseCase"


const setEmailUseCase = (store: UpdateSubscribeStore, value: string) => 
    updateSubscribeUseCase(store, value, setEmail);


export { setEmailUseCase }